export const needsCurrencyFormatting = (input) => {
    if (!input)
        return false;
    return !Number.isNaN(Number(input));
};
